<template>
  <div id="alert-general">
    <b-alert show :variant="variant" class="mt-3">
      <div class="text-alert-modal" :v-if="icon">
        <img
          class="img-alert-modal mr-2 mb-1"
          src="@/assets/images/icons/warning_.svg"
          width="15%"
        />
        {{ text }}
      </div>
    </b-alert>
  </div>
</template>
<script>
export default {
  name: "alert-general",
  props: {
    disabled: {
      default: false,
      type: Boolean,
    },
    text: {
      default: "",
      type: String,
    },
    variant: {
      default: "",
      type: String,
    },
    icon:{
        default:false,
        type: Boolean
    }
  },
  emits: ["click:emit"],
  data() {
    return {};
  },
  beforeMount() {},
  methods: {},
};
</script>
<style lang="scss">
#save-modal {
  .button-primary {
  }
  .button-save-modal {
    background: #5d5fef !important;
    border-radius: 8px !important;
  }
}
</style>